export default __webpack_public_path__ + "static/media/door.bec5fc9c.jpg";